import {message} from "antd";
import {t} from "i18next";
import {getCardById, updateCard} from "@model/card";
import {updateHighlight} from "@model/highlight";
import {EVENT_REFRESH_LIBRARY_LIST} from "@/Const";
import {videoCache} from "../@excalidraw/packages/excalidraw/components/App";
import dayjs from "dayjs";
import {getTimeText} from "@/utils";

/**
 * 导出注记
 * @param highlight
 */
export const exportCurrentElementVideoNotes = (highlight:any) => {
    const exportValues = {
        videoTitle: highlight.name,
        pastedText: highlight.data.reduce((pre, item) => {
            return `${pre}[timestamp]:${getTimeText(item.time)}
${item.title}
${item.content}
`;
        }, ""),
    };
    return exportValues;
};

/**
 * 获取文本
 * @param highlight
 */
export const getCurrentElementVideoNotes = (highlight:any) => {
    const exportValues = highlight.data.reduce((pre, item) => {
        return `${pre}[timestamp]:${getTimeText(item.time)}
${item.title}
${item.content}
`;
    }, "");

    return exportValues;
};

/**
 * 导入高亮
 * @param file
 * @param content
 */
export const onImportHighlights = (file, content,item) => {
    if (file) {
        importCurrentElementVideoNotes({target: {files: [file]}},item)
    } else if (content) {
        importText(content,item);
    }
}

const importCurrentElementVideoNotes = (
    event: React.ChangeEvent<HTMLInputElement>,item:any) => {
    const files = event.target.files;
    if (!files || files.length === 0) {
        return;
    }

    const file = files[0];
    const reader = new FileReader();
    reader.onload = (event: ProgressEvent<FileReader>) => {
        const fileContent = event.target?.result as any;
        importText(fileContent,item);
    };
    reader.readAsText(file);
};

/**
 * 读取文本内容
 * @param file
 */
export const readFileText = (file)=>{
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = (event: ProgressEvent<FileReader>) => {
            const fileContent = event.target?.result as any;
            resolve(fileContent);
        };
        reader.readAsText(file);
    })

}

export const getSpecificTimeOfDay = (
    hours: number,
    minutes: number,
    seconds: number,
) => {
    // 获取当前日期
    const currentDate = dayjs();
    // 设置指定时间
    const specificTime = currentDate.hour(hours).minute(minutes).second(seconds);
    return specificTime;
};
const groupByTimestamp = (data: string[]): string[][] => {
    const groups: string[][] = [];
    let currentGroup: string[] = [];

    data.forEach((item) => {
        if (item.startsWith("[timestamp]:")) {
            if (currentGroup.length > 0) {
                groups.push(currentGroup);
            }
            currentGroup = [item];
        } else {
            currentGroup.push(item);
        }
    });

    if (currentGroup.length > 0) {
        groups.push(currentGroup);
    }

    return groups;
};

const timeString2HoursMinutesSeconds = (timeString: string) => {
    const parts = timeString.split(":");

    // 提取小时、分钟和秒，并将它们转换为数字
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    const seconds = parseInt(parts[2], 10);
    return {
        hours,
        minutes,
        seconds,
    };
};

/**
 * 导入文本
 * @param content
 */
const importText = (content: string,item:any) => {
    if (!content) {
        message.error(t("InvalidHighlightFormat"));
        return;
    }

    const data = content.split("\n");
    const groups = groupByTimestamp(data);

    let newElementVideoNotes: any = null;
    if (!content.includes('[timestamp]:')) {
        newElementVideoNotes = [];
        for (let i = 0; i < data.length; i++) {
            const arrayItem = data[i].trim().split(' ');
            if (arrayItem.length >= 2) {
                const hoursMinutesSeconds = timeString2HoursMinutesSeconds(
                    '00:' + arrayItem[0],
                );
                const szText = data[i].trim().replace(arrayItem[0], '').trim();
                newElementVideoNotes.push({
                    id: `${Date.now()}${i}`,
                    title: szText,
                    content: '',
                    time: getSpecificTimeOfDay(
                        hoursMinutesSeconds.hours,
                        hoursMinutesSeconds.minutes,
                        hoursMinutesSeconds.seconds,
                    ).valueOf()
                })
            }
        }
    } else {
        newElementVideoNotes = groups.map((group, index) => {
            // const filterGroup =
            //     index === groups.length - 1
            //         ? group.slice(0, -3)
            //         : group.slice(0, -2);
            // let [timestampString, title] = filterGroup;
            // timestampString = timestampString?.trim();
            let timestampString = group[0];
            timestampString = timestampString?.trim();

            let szTitle = '';
            let szContent = '';
            if (group.length > 1) {
                szTitle = group[1];
            }

            if (group.length > 2) {
                for (let g=2;g<group.length;g++){
                    szContent += group[g]+'\n';
                }
                if (szContent.length > 1){
                    szContent = szContent.substring(0,szContent.length -1);
                }
            }
            if (timestampString) {
                const hoursMinutesSeconds = timeString2HoursMinutesSeconds(
                    timestampString.slice(-8),
                );
                return {
                    id: `${Date.now()}${index}`,
                    title: szTitle,
                    content: szContent,//filterGroup.slice(2).join("\n"),
                    time: getSpecificTimeOfDay(
                        hoursMinutesSeconds.hours,
                        hoursMinutesSeconds.minutes,
                        hoursMinutesSeconds.seconds,
                    ).valueOf(),
                };
            }
            return null;
        });
    }

    //加入之前的...
    newElementVideoNotes.push(...item.data);
    //按时间排序
    newElementVideoNotes.sort((a, b) => {
        return a.time - b.time;
    })

    if (newElementVideoNotes.some(p => p != null && p?.time)) {
        videoCache.set(item.id, newElementVideoNotes);
        updateToDb(newElementVideoNotes,item);

        let szType = 'videoAnno';
        if (item.type == 'audio'){
            szType = 'audioAnno';
        }
        //更新到库
        newElementVideoNotes.forEach(async (annoItem:any) => {
            const videoAnno = {
                ...annoItem,
                name:item.name,
                type:szType
            }
            //标签
            const dbItem = await getCardById(annoItem.id);
            if (dbItem) {
                videoAnno.tags = dbItem.tags;
            }
            await updateCard(videoAnno);
        })

        window.closeDialogImportHighlight();
    } else {
        message.error(t("InvalidHighlightFormat"));
    }
}

export const getSeconds = (timestamp: number) => {
    const dayjsObject = dayjs(timestamp);
    const hours = dayjsObject.hour();
    const minutes = dayjsObject.minute();
    const seconds = dayjsObject.second();
    return hours * 3600 + minutes * 60 + seconds;
};

/**
 * 保存到数据库
 * @param newElementVideoNotes
 */
const updateToDb = (newElementVideoNotes: any,item:any) => {
    //保存到数据库
    updateHighlight({
        ...item,
        data: newElementVideoNotes
    }).then(res => {
        postMessage(EVENT_REFRESH_LIBRARY_LIST);
    });
}


/************************************************翻译部分******************************/
function parseYouTubeTranscript(text) {
    const lines = text.split(/\r?\n/).map(line => line.trim()).filter(line => line !== '');
    const result = [];
    let i = 0;

    // 跳过开头无时间的行（如 "Intro"）
    while (i < lines.length && !/^\d+:\d{2}$/.test(lines[i])) {
        i++;
    }

    while (i < lines.length) {
        // 当前行必须是时间戳，如 "0:00", "2:10"
        if (!/^\d+:\d{2}$/.test(lines[i])) {
            i++; // 容错：跳过异常行
            continue;
        }

        const timeStr = lines[i];
        const start = parseYoutubeTimeToSeconds(timeStr);

        // 下一行是文本（可能有多行？这里按单行为准）
        let text = '';
        i++;
        while (i < lines.length && !/^\d+:\d{2}$/.test(lines[i])) {
            if (text) text += ' ';
            text += lines[i];
            i++;
        }

        // 推算 end：看下个时间戳，若无则 +3 秒
        let end = start + 3;
        if (i < lines.length && /^\d+:\d{2}$/.test(lines[i])) {
            end = parseYoutubeTimeToSeconds(lines[i]);
        }

        if (text.trim()) {
            result.push({id:timeStr, start, end, content: text.trim() });
        }
    }

    if (result.length >0){
        window.closeDialogImportTranscript();
    }


    return result;
}

// 辅助函数：将 "M:SS" 转为秒数
function parseYoutubeTimeToSeconds(timeStr) {
    const [min, sec] = timeStr.split(':').map(Number);
    return min * 60 + sec;
}


function parseTimeToSeconds(timeStr) {
    // 支持 "00:00:01,760" 或 "00:00" 或 "1:23"
    if (timeStr.includes('-->')) return null;

    // 处理带毫秒的格式（如 00:00:01,760）
    if (timeStr.includes(',')) {
        const [timePart] = timeStr.split(',');
        const parts = timePart.split(':').map(Number);
        if (parts.length === 3) {
            return parts[0] * 3600 + parts[1] * 60 + parts[2];
        } else if (parts.length === 2) {
            return parts[0] * 60 + parts[1];
        }
    }

    // 处理 MM:SS 或 M:SS 格式（如 01:23）
    const colonCount = (timeStr.match(/:/g) || []).length;
    if (colonCount === 1) {
        const [min, sec] = timeStr.split(':').map(Number);
        return min * 60 + sec;
    }else if (colonCount == 2){
        const [hou,min, sec] = timeStr.split(':').map(Number);
        return hou*3600 + min * 60 + sec;
    }

    // 纯数字秒？基本不用，但兜底
    const num = parseFloat(timeStr);
    return isNaN(num) ? 0 : num;
}

function detectNRTxtFeatures(text) {
    try {
        const lines = text.split('\n').map(l => l.trim()).filter(l => l);
        const timecodeLineCount = lines.filter(l => /^\d{2}:\d{2}\s+/.test(l)).length;
        const hasContinuationLines = lines.some((l, i) =>
            i > 0 && !/^\d{2}:\d{2}\s+/.test(l) && /^\d{2}:\d{2}\s+/.test(lines[i - 1])
        );

        return {
            format: 'timestamp-with-multi-line-text',
            timeFormat: 'MM:SS',
            totalLines: lines.length,
            timecodeLines: timecodeLineCount,
            hasTextWrap: hasContinuationLines, // 关键特征！
            language: 'French'
        };
    }catch (e){

    }
    return {
        hasTextWrap: false, // 关键特征！
    }
}

export function importTranscriptFromContent(content) {
    // content = content.replace(/\n(?!\d{2}:\d{2})/g, ' ');
    if (detectNRTxtFeatures(content).hasTextWrap){
        content = content.replace(/\n(?!\d{2}:\d{2})/g, ' ');
    }
    //去掉前面的无用--这些本也不好去。只能根据这个。
    const lines = content.split(/\r?\n/).map(line => line.trim()).filter(line => line !== '');

    // 启发式判断：如果大量行匹配 /^\d+:\d{2}$/，则用 YouTube 换行模式
    const timeLineCount = lines.filter(line => /^\d+:\d{2}$/.test(line)).length;
    if (timeLineCount >= 2 && timeLineCount / lines.length > 0.2) {
        return parseYouTubeTranscript(content);
    }

    const result = [];
    let i = 0;

    while (i < lines.length) {
        const line = lines[i].replace(/[\r\n]+\s*/g, ' ');

        // 情况1：检测到时间轴行（包含 -->）
        if (line.includes('-->')) {
            const [startStr, endStr] = line.split('-->').map(s => s.trim());
            const start = parseTimeToSeconds(startStr);
            const end = parseTimeToSeconds(endStr);
            let text = '';
            i++;
            // 收集后续非时间行作为文本（直到下一个时间行或结束）
            while (i < lines.length && !lines[i].includes('-->') && !/^\d+$/.test(lines[i])) {
                text += (text ? ' ' : '') + lines[i];
                i++;
            }
            if (text) result.push({id:startStr, start, end, content:text });
            continue;
        }

        // 情况2：YouTube 风格：时间戳在行首，如 "00:00 I am like..."
        let timeMatch = line.match(/^(\d{1,2}:\d{2}(?::\d{2})?(?:,\d{3})?)\s+(.+)$/);
        if (timeMatch) {
            const timeStr = timeMatch[1];
            const text = timeMatch[2].trim();
            const start = parseTimeToSeconds(timeStr);
            // 找下一行的时间作为 end，否则估算（+5秒）
            let end = start + 5;
            if (i + 1 < lines.length) {
                const nextLine = lines[i + 1];
                const nextTimeMatch = nextLine.match(/^(\d{1,2}:\d{2}(?::\d{2})?(?:,\d{3})?)/);
                if (nextTimeMatch) {
                    end = parseTimeToSeconds(nextTimeMatch[1]);
                }
            }
            result.push({id:timeStr,start, end, content:text });
            i++;
            continue;
        }

        // 兼容两种格式：----这种是从程序复制出来的。。。。。
    // 1. "00:00:00 text" （YouTube 风格）
    // 2. "00:00:00" 单独一行，下一行是文本
        timeMatch = line.match(/^(\d{1,2}:\d{2}(?::\d{2})?(?:,\d{3})?)(?:\s+(.+))?$/);
        if (timeMatch) {
            const timeStr = timeMatch[1];
            let text = '';

            // 情况1：本行有文本（YouTube 风格）
            if (timeMatch[2] != null && timeMatch[2].trim() !== '') {
                text = timeMatch[2].trim();
            }
            // 情况2：本行只有时间戳，尝试取下一行作为文本
            else if (i + 1 < lines.length) {
                const nextLine = lines[i + 1].trim();
                // 确保下一行不是另一个时间戳（避免误吞）
                const isNextTime = /^(\d{1,2}:\d{2}(?::\d{2})?(?:,\d{3})?)$/.test(nextLine);
                if (!isNextTime && nextLine !== '') {
                    text = nextLine;
                    i++; // 跳过下一行（已被消费）
                }
                // 如果下一行是时间戳或空，则 text 保持为空（合法）
            }

            const start = parseTimeToSeconds(timeStr);
            let end = start + 5;

            // 找真正的下一个时间戳行（从 i+1 开始往后找，跳过已消费的行）
            let searchStart = i + 1;
            for (let j = searchStart; j < lines.length; j++) {
                const nextLine = lines[j].trim();
                const nextTimeMatch = nextLine.match(/^(\d{1,2}:\d{2}(?::\d{2})?(?:,\d{3})?)$/);
                if (nextTimeMatch) {
                    end = parseTimeToSeconds(nextTimeMatch[1]);
                    break;
                }
            }

            result.push({ id: timeStr, start, end, content: text });
            continue; // 注意：如果消费了下一行，i 已经在上面 ++；否则正常循环
        }

        // 情况3：Obsidian/普通文本（无时间）→ 跳过或设为 null 时间（这里跳过）
        i++;
    }

    if (result.length >0){
        window.closeDialogImportTranscript();
    }

    return result;
}

